export const urlPage = "Page";
export const urlInternal = "UtraInternal";

export const URLImgFront = "https://www.utrahuilca.coop/StaticFiles";
export const _utuaForm = "UTRAP4G1NA";